@if((corporateTaxEntity$ | async) && (vpbBerekening$ | async)) {
  <div style="max-width: 80%">
    <form [formGroup]="fiscaleWinstFg">
      <div class="row">
        <div class="col col-1">
          <p>Eindvermogen volgens balans</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="eindvermogen"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col col-1">
          <p>Beginvermogen volgens balans</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="beginvermogen"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col col-1">
          <p>Vermogensverschil</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="vermogensverschil"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="onttrekkingenFg">
      <div class="row">
        <div class="col col-1">
          <p>Bij: onttrekkingen van kapitaal gedurende het boekjaar</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="bedrag"
                                            id="onttrekkingen"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="stortingenFg">
      <div class="row">
        <div class="col col-1">
          <p>Af: stortingen van kapitaal gedurende het boekjaar</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="bedrag"
                                            id="stortingen"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="nietAftrekbareBedragenFg">
      <div class="row">
        <div class="col col-1">
          <p>Bij: vennootschapsbelasting</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="vennootschapsbelasting"
                                            id="vennootschapsbelasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col col-1">
          <p>Bij: buitenlandse winstbelasting</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="buitenlandseWinstbelasting"
                                            id="buitenlandseWinstbelasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>

      <div class="row">
        <div class="col col-1">
          <p>Bij: andere uitdelingen van winst</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control (change)="saveForm()"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="nietAftrekbareKapitaalsvergoedingen"
                                            id="nietAftrekbareKapitaalsvergoedingen"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="fiscaleWinstFg">
      <div class="row">
        <div class="col col-1">
          <p>Fiscale winst volgens vermogensvergelijking</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="saldoFiscaleWinst"
                                            id="saldoFiscaleWinst"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="fiscaleWinstResultatenrekeningFg">
      <div class="row">
        <div class="col col-1">
          <p>Fiscale winst volgens resultatenrekening</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="saldoFiscaleWinstberekening"
                                            id="saldoFiscaleWinstberekening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </div>
}
